<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="inputForm.projectName" label="物业项目名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.houseName || inputForm.installationSite" label="资源/安装地点" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.changeDate" label="换表时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
      <van-collapse-item title="旧表" name="2">
        <van-field v-model="inputForm.oldMeterNumber" label="管理编码" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.meterCode" label="设备编码" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.oldMeterName" label="计量表名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="meterAttribute" label="计量表属性" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.oldTimes" label="倍率" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.oldMeasuringRange" label="量程" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.oldPrevReading" label="上次读数" label-width="100px" readonly input-align="left" :border="false" type="text" :formatter="formatter"
                   format-trigger="onChange" />
        <van-field v-model="inputForm.oldPrevReadingDate" label="上次抄表时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.oldLastReading" label="换表时读数" label-width="100px" readonly input-align="left" :border="false" type="text" :formatter="formatter"
                   format-trigger="onChange"/>
        <van-field v-model="inputForm.oldLastQuantity" label="实际用量" label-width="100px" readonly input-align="left" :border="false" type="text" :formatter="formatter"
                   format-trigger="onChange"/>
        <van-field v-model="oldLossRate" label="损耗率" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="oldLastLossQuantity" label="损耗值" label-width="100px" readonly input-align="left" :border="false" type="text" :formatter="formatter"
                   format-trigger="onChange" />
        <van-field v-model="oldTotalQuantity" label="总用量" label-width="100px" readonly input-align="left" :border="false" type="text" :formatter="formatter"
                   format-trigger="onChange"/>
      </van-collapse-item>
      <van-collapse-item title="新表" name="3">
        <van-field v-model="inputForm.newMeterNumber" label="管理编码" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.newMeterCode" label="设备编码" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.newMeterName" label="计量表名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="newMeterAttribute" label="计量表属性" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.newTimes" label="倍率" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.newMeasuringRange" label="量程" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="newLossRate" label="损耗率" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.newInitReading" label="初始值" label-width="100px" readonly input-align="left" :border="false" type="text" :formatter="formatter"
                   format-trigger="onChange"/>
      </van-collapse-item>
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import { Decimal } from "decimal.js"
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "meterChange",
  data(){
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      inputForm: {
        isDoTask: false,
        isLastTask: false,
        projectName: '',
        houseName: '',
        installationSite: '',
        changeDate: '',
        oldMeterNumber: '',
        meterCode: '',
        oldMeterName: '',
        meterAttribute: '',
        oldTimes: '',
        oldMeasuringRange: '',
        oldPrevReading: '',
        oldPrevReadingDate: '',
        oldLastReading: '',
        oldLastQuantity: '',
        oldLossRate: '',
        oldLastLossQuantity: '',
        newMeterNumber: '',
        newMeterCode: '',
        newMeterName: '',
        newMeterAttribute: '',
        newTimes: '',
        newMeasuringRange: '',
        newLossRate: '',
        newInitReading: '',
        newTotalQuantity: '',
        newTotalLossQuantity: '',
      },
      oldLastLossQuantity: '',
      oldTotalQuantity: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  computed: {
    // oldLastLossQuantity(){
    //   return new Decimal(this.inputForm.oldLastQuantity).mul(this.inputForm.oldLossRate).toFixed(+this.inputForm.decimalPlaces, Decimal.ROUND_HALF_UP)
    // },
    // oldTotalQuantity(){
    //   return new Decimal(this.inputForm.oldLastQuantity).add(this.oldLastLossQuantity).toFixed(+this.inputForm.decimalPlaces, Decimal.ROUND_HALF_UP)
    // },
    meterAttribute(){
      switch (this.inputForm.oldMeterAttribute) {
        case '1':
          return '不计费'
        case '2':
          return '计费预充值'
        case '3':
          return '计费非预充值'
        default:
          return ''
      }
    },
    newMeterAttribute(){
      switch (this.inputForm.newMeterAttribute) {
        case '1':
          return '不计费'
        case '2':
          return '计费预充值'
        case '3':
          return '计费非预充值'
        default:
          return ''
      }
    },
    oldLossRate(){
      return (this.inputForm.oldLossRate * 100).toFixed(2) + '%'
    },
    newLossRate(){
      return (this.inputForm.newLossRate * 100).toFixed(2) + '%'
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/base/wuyeBaseMeterChange/queryById').then(({ data }) => {
        this.inputForm = data
        this.oldLastLossQuantity = new Decimal(this.inputForm.oldLastQuantity).mul(this.inputForm.oldLossRate).toFixed(+this.inputForm.decimalPlaces, Decimal.ROUND_HALF_UP)
        this.oldTotalQuantity = new Decimal(this.inputForm.oldLastQuantity).add(this.oldLastLossQuantity).toFixed(+this.inputForm.decimalPlaces, Decimal.ROUND_HALF_UP)
      }).catch(e => {
        console.log(e)
      })
    },
    formatter(value) {
      // 过滤输入的数字
      return Number(value).toFixed(this.inputForm.decimalPlaces);
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(_this.inputForm, '/base/wuyeBaseMeterChange/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          _this.$flow.startFlow(_this.inputForm, '/base/wuyeBaseMeterChange/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>

</style>